import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  sectionHeaderWrapper: {
    gap: theme.spacing(3),
  },
  textContentWrapper: {
    gap: theme.spacing(1.25),
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: theme.spacing(2),
  },
  colorSelectorWidth: {
    width: '265px',
  },
  sectionHeaderContainer: {
    width: '100%',
    height: theme.spacing(3),
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  verticalDivider: {
    height: theme.spacing(3),
    width: theme.spacing(0.125),
    backgroundColor: theme.palette.dividerV2.main,
  },
  helpDrawer: {
    alignSelf: 'self-end',
  },
  infoIcon: {
    height: '16px',
    width: '16px',
    fontSize: '16px',
    color: theme.palette.select.light,
    alignContent: 'center',
    fontWeight: 400,
  },
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  content: {
    padding: theme.spacing(4, 5),
  },
  sectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    height: 'auto',
  },
  textHeading: {
    color: '#381E1C',
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.25px',
  },
}))
